import { composeIO } from 'react-compose-io'
import { dadosSequenciaisIO } from './DadosSequenciais.IO'
import DadosSequenciaisView from './DadosSequenciais.View'

export const DadosSequencias = composeIO(DadosSequenciaisView, dadosSequenciaisIO)
